<template>
    <div class="show-wrap">
        <!-- 各种风格介绍（数据来自后台介绍管理） -->
        <section id="style">
            <h2 class="section-title style-title">
                <span class="main-title"><span class="ch ch1">视</span><span class="ch ch2">觉</span><span class="ch ch3">美</span><span class="ch ch4">学</span><span class="ch ch5">设</span><span class="ch ch6">计</span></span>
                <span class="sub-title">AESTHETIC DESIGN</span>
            </h2>
            <div class="intro-container">
                <div class="intro-box" v-for="item in intros" :key="item.id">
                    <h2>{{ item.title }}</h2>
                    <p>{{ item.content }}</p>
                </div>
            </div>
        </section>

        <!-- 物语小店商品展示（后台勾选展示的商品，无价格） -->
        <section id="showcase" style="background:#fff7fb">
            <h2 class="section-title showcase-title">
                <span class="main-title"><span class="ch ch1">物</span><span class="ch ch2">语</span><span class="ch ch3">宝</span><span class="ch ch4">藏</span><span class="ch ch5">鉴</span><span class="ch ch6">赏</span></span>
                <span class="sub-title">TREASURE · GALLERY · COLLECTION</span>
            </h2>
            <div class="gallery-wrap">
                <div class="card" v-for="p in products" :key="p.id">
                    <div class="card-img">
                        <el-image :src="imgUrl(p.image)" :alt="p.name" fit="cover"
                                  :preview-src-list="imgUrl(p.image) ? [imgUrl(p.image)] : []"
                                  preview-teleported
                                  @error="imgErr"></el-image>
                    </div>
                    <div class="card-body">
                        <h3>{{ p.name }}</h3>
                        <p>{{ p.description }}</p>
                        <div class="tag-group" v-if="tagList(p).length > 0">
                            <span class="tag" v-for="(t, i) in tagList(p)" :key="i">{{ t }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // 商品图片统一从 src/components/Storyshop/shop 目录打包加载
    const shopImages = require.context('../Storyshop/shop', false, /\.(jpg|jpeg|png|gif)$/)

    export default {
        name: "HomeShowcase",
        data() {
            return {
                intros: [],
                products: []
            }
        },
        methods: {
            imgUrl(file) {
                if (!file) return ''
                try {
                    return shopImages('./' + file)
                } catch (e) {
                    return ''
                }
            },
            imgErr(e) {
                e.target.style.display = 'none'
            },
            tagList(p) {
                if (!p.tags) return []
                return p.tags.split(/[,，]/).map(s => s.trim()).filter(Boolean)
            },
            loadIntros() {
                this.$axios.get(this.$httpUrl + '/intro/list').then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.intros = res.data || []
                    }
                })
            },
            loadProducts() {
                this.$axios.get(this.$httpUrl + '/shop/list', {
                    params: {show: 'Y'}
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.products = res.data || []
                    }
                })
            }
        },
        beforeMount() {
            this.loadIntros()
            this.loadProducts()
        }
    }
</script>

<style scoped>
    .show-wrap {
        width: 100%;
    }

    /*通用区块*/
    section {
        padding: 80px 5%;
        scroll-margin-top: 70px; /* 顶部导航固定定位，滚动定位时让出高度 */
    }

    .section-title {
        text-align: center;
        font-size: 34px;
        color: #b84f80;
        margin-bottom: 50px;
        position: relative
    }

    .section-title::after {
        content: "";
        width: 100px;
        height: 3px;
        background: #ff98c2;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -12px;
        border-radius: 3px
    }

    /* 视觉美学设计 / 物语宝藏鉴赏：主标题轻柔错落 + 英文副标题 */
    .showcase-title, .style-title {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 60px;
        line-height: 1.35
    }
    .showcase-title .main-title, .style-title .main-title {
        display: inline-block;
        letter-spacing: 2px;
        line-height: 1.3
    }
    .showcase-title .ch, .style-title .ch {
        display: inline-block;
        font-weight: 600;
        margin: 0 2px;
        background: linear-gradient(160deg, #f27db0, #d95a96 45%, #a97fe8);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        filter: drop-shadow(0 2px 6px rgba(255, 150, 205, 0.30))
    }
    .ch1 { font-size: 42px; transform: translateY(-5px) }
    .ch2 { font-size: 46px; transform: translateY(4px) }
    .ch3 { font-size: 40px; transform: translateY(-7px) }
    .ch4 { font-size: 48px; transform: translateY(3px) }
    .ch5 { font-size: 41px; transform: translateY(-4px) }
    .ch6 { font-size: 44px; transform: translateY(6px) }
    .showcase-title .sub-title, .style-title .sub-title {
        font-size: 13px;
        letter-spacing: 5px;
        text-transform: uppercase;
        color: rgba(185, 95, 140, 0.78);
        margin-top: 12px;
        font-family: Georgia, serif;
        text-indent: 5px
    }
    .showcase-title::after, .style-title::after {
        content: "";
        width: 120px;
        height: 3px;
        background: linear-gradient(90deg, transparent, #ff9ecb, #c9a6ff, #ff9ecb, transparent);
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -12px;
        border-radius: 3px;
        box-shadow: 0 0 10px rgba(255, 140, 205, 0.6)
    }

    /*三大品类介绍区*/
    .intro-container {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 32px;
        margin-top: 20px
    }

    .intro-box {
        padding: 42px 34px;
        background: url('../../assets/img/边框.png') no-repeat center / 100% 100%;
        transition: 0.3s
    }

    .intro-box:hover {
        transform: scale(1.02);
        filter: drop-shadow(0 10px 20px rgba(255, 160, 205, 0.4))
    }

    .intro-box h2 {
        font-size: 24px;
        margin-bottom: 14px;
        color: #bd4e82
    }

    .intro-box p {
        color: #704256;
        line-height: 1.8;
        font-size: 15px
    }

    /*服饰卡片容器*/
    .gallery-wrap {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 36px
    }

    .card {
        padding: 14px;
        background: #fff;
        border-radius: 30px;
        overflow: hidden;
        transition: 0.4s ease;
        position: relative
    }

    /* 竖边框图层压在商品展示图片之上 */
    .card::after {
        content: "";
        position: absolute;
        inset: 0;
        background: url('../../assets/img/竖边框.png') no-repeat center / 100% 100%;
        pointer-events: none;
        z-index: 3
    }

    .card:hover {
        transform: translateY(-12px);
        box-shadow: 0 12px 30px rgba(255, 184, 216, 0.45)
    }

    .card-img {
        width: 100%;
        height: 260px;
        border-radius: 10px;
        background: linear-gradient(135deg, #ffd6e7, #ffe6f2);
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        cursor: zoom-in
    }

    .card-img .el-image {
        width: 100%;
        height: 100%;
        display: block
    }

    .card-img .el-image__inner {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block
    }

    .card-body {
        padding: 20px
    }

    .card-body h3 {
        font-size: 22px;
        color: #c25286;
        margin-bottom: 10px
    }

    .card-body p {
        color: #704256;
        line-height: 1.5;
        font-size: 15px;
        min-height: 52px
    }

    .tag-group {
        margin-top: 10px;
        display: flex;
        gap: 8px;
        flex-wrap: wrap
    }

    .tag {
        padding: 4px 12px;
        background: #ffe0ec;
        border-radius: 16px;
        font-size: 13px;
        color: #b04c7a
    }
</style>
